/**
 * The main-thread IndexedDB client: store-passing wrappers over `idb-core`.
 * See .claude/context/persistence.md
 */
import * as core from './idb-core';

/**
 * Public API. Generic CRUD methods take a `store` name so one client serves every
 * object store; the cursor ops hardcode the messages store inside `idb-core`.
 */
export const idbClient = {
  // Generic CRUD -----------------------------------------------------------
  getAll: (store) => core.getAll(store),
  add: (store, record) => core.add(store, record),
  update: (store, record) => core.update(store, record),
  get: (store, key) => core.get(store, key),
  put: (store, record) => core.put(store, record),

  // Cursor-driven message ops (store implied by the op) --------------------
  insertIfAbsent: (store, record, matchField) => core.insertIfAbsent(store, record, matchField),
  clearMessages: (opts) => core.clearMessages(opts || {}),
  cleanOrphans: (opts) => core.cleanOrphans(opts || {}),
};
